<div class="modal-content">
    <div class="modal-header">
        {{title}}
    </div>
    <div class="modal-body">
        <ng-content #content *ngIf="LoadedComplete()"></ng-content>
    </div>
</div>

